import { toast } from 'sonner';

export const showToast = {
  success: (message: string, description?: string) => {
    const options = {
      duration: 4000,
      ...(description ? { description } : {}),
    };
    toast.success(message, {
      ...options,
    });
  },

  error: (message: unknown, description?: string) => {
    // Always extract a string from any error-like object
    let errorMessage = 'An error occurred';
    if (typeof message === 'string') {
      errorMessage = message;
    } else if (message && typeof message === 'object') {
      const obj = message as Record<string, unknown>;
      if ('message' in obj && typeof obj.message === 'string') {
        errorMessage = obj.message;
      } else if ('code' in obj && typeof obj.code === 'string') {
        errorMessage = obj.code;
      } else {
        try {
          errorMessage = JSON.stringify(message);
        } catch {}
      }
    }
    toast.error(errorMessage, {
      duration: 5000,
      ...(description ? { description } : {}),
    });
  },

  warning: (message: string, description?: string) => {
    toast.warning(message, {
      duration: 4500,
      ...(description ? { description } : {}),
    });
  },

  info: (message: string, description?: string) => {
    toast.info(message, {
      duration: 4000,
      ...(description ? { description } : {}),
    });
  },

  loading: (message: string, description?: string) => {
    return toast.loading(message, {
      duration: Infinity,
      ...(description ? { description } : {}),
    });
  },

  dismiss: (toastId?: string | number) => {
    if (toastId) {
      toast.dismiss(toastId);
    } else {
      toast.dismiss();
    }
  },

  promise: async <T>(
    promise: Promise<T>,
    {
      loading,
      success,
      error,
    }: {
      loading: string;
      success: string | ((data: T) => string);
      error: string | ((error: any) => string);
    }
  ) => {
    const normalizedError =
      typeof error === 'function'
        ? (err: any) => String(error(err))
        : error;
    return toast.promise(promise, {
      loading,
      success,
      error: normalizedError,
    });
  },
};
